export default "__VITE_ASSET__DD8$r8q1__"